import React from 'react';

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

const thStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  backgroundColor: '#f0f0f0',
  textAlign: 'left',
};

const tdStyle = {
  border: '1px solid #ccc',
  padding: '8px',
};

function PaymentTable({ payments }) {
  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle}>Student Name</th>
          <th style={thStyle}>Amounts</th>
          <th style={thStyle}>Date</th>
          <th style={thStyle}>Method</th>
          <th style={thStyle}>Transaction ID</th>
          <th style={thStyle}>Status</th>
        </tr>
      </thead>
      <tbody>
        {payments.map((payment, index) => (
          <tr key={index}>
            <td style={tdStyle}>{payment.studentName}</td>
            <td style={tdStyle}>{payment.amount}</td>
            <td style={tdStyle}>{payment.date}</td>
            <td style={tdStyle}>{payment.method}</td>
            <td style={tdStyle}>{payment.transactionId}</td>
            <td style={tdStyle}>{payment.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default PaymentTable;
